// src/store/index.js
import '@/utils/migrateLegacyStorage'
import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { STORAGE_KEYS } from '@/constants/appIdentity'
import user from './modules/user'
import config from './modules/config'
import notification from './modules/notification'

export default createStore({
    plugins: [
        createPersistedState({
            key: STORAGE_KEYS.vuex,
            paths: [
                'user',
                'config'
            ],
            storage: window.localStorage,
        })
    ],
    modules: {
        user,
        config,
        notification
    }
})
